<ng-container *ngIf="!!element?.anexo_principal">
  <ng-container *ngIf="token$ | async as token">
    <div
      class="h-[638px] w-full rounded-tl-2xl bg-[#fafafa] shadow-xl"
      [ngClass]="{
        'rounded-tr-2xl': fullWidth || fullSize,
        'rounded-bl-2xl rounded-br-2xl': fullSize
      }"
    >
      <iframe
        class="h-[638px] w-full rounded-tl-2xl"
        style="background-color: #000"
        [ngClass]="{
          'rounded-tr-2xl': fullWidth || fullSize,
          'rounded-bl-2xl rounded-br-2xl': fullSize
        }"
        [src]="urlFlip(element.anexo_principal, token) | safe : 'resourceUrl'"
        [title]="element.titulo"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </ng-container>
</ng-container>
